export const ACTION_TYPES = [
  { key: "segnala_guasto", label: "Segnala Guasto", icon: "AlertTriangle", bg: "bg-red-600", hover: "hover:bg-red-500", text: "text-white" },
  { key: "richiedi_carburante", label: "Richiedi Carburante", icon: "Fuel", bg: "bg-orange-600", hover: "hover:bg-orange-500", text: "text-white" },
  { key: "richiedi_olio", label: "Richiedi Olio", icon: "Droplet", bg: "bg-amber-500", hover: "hover:bg-amber-400", text: "text-slate-950" },
  { key: "richiedi_adblue", label: "Richiedi AdBlue", icon: "Container", bg: "bg-blue-600", hover: "hover:bg-blue-500", text: "text-white" },
  { key: "ruota_forata", label: "Ruota Forata / Danneggiata", icon: "CircleDot", bg: "bg-purple-600", hover: "hover:bg-purple-500", text: "text-white" },
  { key: "luce_rotta", label: "Luce Rotta", icon: "Lightbulb", bg: "bg-emerald-600", hover: "hover:bg-emerald-500", text: "text-white" },
  { key: "manutenzione", label: "Manutenzione", icon: "Wrench", bg: "bg-slate-700", hover: "hover:bg-slate-600", text: "text-slate-100" },
  { key: "altro", label: "Altro", icon: "MoreHorizontal", bg: "bg-slate-800", hover: "hover:bg-slate-700", text: "text-slate-200" },
];

export const STATUS_META = {
  aperto: { label: "Aperto", cls: "bg-red-500/10 text-red-400 border-red-500/30", dot: "#ef4444" },
  preso_in_carico: { label: "Preso in carico", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30", dot: "#f59e0b" },
  in_riparazione: { label: "In riparazione", cls: "bg-blue-500/10 text-blue-400 border-blue-500/30", dot: "#3b82f6" },
  da_approvare: { label: "Da approvare", cls: "bg-fuchsia-500/10 text-fuchsia-400 border-fuchsia-500/30", dot: "#d946ef" },
  risolto: { label: "Risolto", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30", dot: "#10b981" },
};

export const STATUS_ORDER = ["aperto", "preso_in_carico", "in_riparazione", "risolto"];

// Richieste = rifornimenti/consumabili (olio, AdBlue, carburante). Tutto il resto è una Segnalazione (problema/guasto del mezzo).
export const isRichiesta = (tipo) => String(tipo || "").startsWith("richiedi_");

export const GRAVITA_META = {
  normale: { label: "Normale", cls: "border-slate-600 text-slate-300", active: "bg-slate-700 border-slate-500 text-white" },
  urgente: { label: "Urgente", cls: "border-amber-500/40 text-amber-300", active: "bg-amber-600 border-amber-400 text-white" },
  mezzo_inutilizzabile: { label: "Mezzo inutilizzabile", cls: "border-red-500/40 text-red-300", active: "bg-red-600 border-red-400 text-white" },
};

// Which fields to show in the operator report form per request type.
export const TYPE_FIELDS = {
  segnala_guasto: { posizione: true, descrizione: true },
  richiedi_carburante: { posizione: false, descrizione: false },
  richiedi_olio: { posizione: false, descrizione: false },
  richiedi_adblue: { posizione: false, descrizione: false },
  ruota_forata: { posizione: true, descrizione: true },
  luce_rotta: { posizione: true, descrizione: false },
  manutenzione: { posizione: false, descrizione: true },
  altro: { posizione: true, descrizione: true },
};

// Types that ask the admin for a quantity when resolving.
export const QUANTITY_TYPES = ["richiedi_olio", "richiedi_adblue", "richiedi_carburante", "ruota_forata"];
export const QUANTITY_LABEL = {
  richiedi_olio: "Quantita' olio aggiunta (es. 2 L)",
  richiedi_adblue: "Quantita' AdBlue aggiunta (es. 5 L)",
  richiedi_carburante: "Carburante rifornito (es. 40 L)",
  ruota_forata: "Dettaglio intervento (es. 1 gomma 205/55 R16)",
};

// Tracciamento costi
export const COST_CATEGORIES = ["Assicurazione", "Bollo", "Leasing/Noleggio", "Revisione", "Manutenzione", "Carburante", "Gomme", "Altro"];
export const RICORRENZA_OPTIONS = [
  { k: "una_tantum", l: "Una tantum" },
  { k: "mensile", l: "Mensile" },
  { k: "annuale", l: "Annuale" },
];
export const RICORRENZA_LABEL = { una_tantum: "Una tantum", mensile: "Mensile", annuale: "Annuale" };
export const fmtEuro = (n) => Number(n || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

// Stato del mezzo
export const VEHICLE_STATI = [
  { k: "OK", l: "OK" },
  { k: "RIPARAZIONE", l: "In riparazione" },
  { k: "INOP", l: "INOP" },
  { k: "DISMESSO", l: "DISMESSO" },
];
export const VEHICLE_STATO_LABEL = { OK: "OK", RIPARAZIONE: "In riparazione", INOP: "INOP", DISMESSO: "DISMESSO" };
export const VEHICLE_STATO_BADGE = {
  OK: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  RIPARAZIONE: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  INOP: "bg-red-500/10 text-red-400 border-red-500/30",
  DISMESSO: "bg-slate-500/10 text-slate-400 border-slate-500/30",
};

// Tipo / categoria del mezzo (anagrafica). Le "attrezzature" (sotto) non compaiono in Dati tecnici / Consumi.
export const VEHICLE_TIPOLOGIE = [
  "Autovettura", "Autocarro", "Furgone",
  "PLE", "Rimorchio", "Trattorino", "GPU", "Estintore", "Attrezzatura",
];
const ATTREZZATURA_TIPOLOGIE_SET = new Set([
  "ple", "rimorchio", "trattorino", "trattorino elettrico", "gpu",
  "estintore", "attrezzatura", "attrezzatura carrello", "attrezzatura scala",
  "piattaforma", "carrello", "scala",
]);
export const isAttrezzatura = (v) => ATTREZZATURA_TIPOLOGIE_SET.has(String(v?.tipologia || "").trim().toLowerCase());

// Attrezzature (registro magazzino: estintori, DPI, ecc.)
export const ATTREZZATURA_TIPI = [
  "Estintore",
  "Cassetta pronto soccorso",
  "Triangolo",
  "Giubbotto catarifrangente",
  "Catene da neve",
  "Kit attrezzi",
  "Altro",
];
export const ATTREZZATURA_STATI = [
  { k: "attiva", l: "Attiva" },
  { k: "dismessa", l: "Dismessa" },
];
